module.exports = __webpack_public_path__ + "static/blogbackground-8784cb962b0593b5efb51100b12ec2ed.jpg";